function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2837",
    d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0m0 30.28A14.28 14.28 0 1 1 30.28 16 14.276 14.276 0 0 1 16 30.28",
    style: {
      fill: "#dcea8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2838",
    d: "M13.585 16.1h3.55v-2.23h-8.41v2.23h4.86zm-4.36-1.73h7.41v1.23h-7.41z",
    style: {
      fill: "#dcea8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2839",
    d: "M13.585 19.092h3.55v-2.23h-8.41v2.23h4.86zm-4.36-1.73h7.41v1.23h-7.41z",
    style: {
      fill: "#dcea8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2840",
    d: "M17.135 21.062v-1.22h-8.41v2.24h8.41zm-.5 0v.52h-7.41v-1.24h7.41z",
    style: {
      fill: "#dcea8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2841",
    d: "M17.545 24.262a1.886 1.886 0 0 0 1.86-1.88v-1.32h4.06a1.871 1.871 0 0 0 1.86-1.87v-9.98a.17.17 0 0 0-.01-.07v-.01a.539.539 0 0 0-.13-.45l-3.07-3.15c-.03-.02-.05-.04-.08-.06a.881.881 0 0 0-.58-.21h-7a1.88 1.88 0 0 0-1.87 1.87v1.32h-4.05a1.871 1.871 0 0 0-1.86 1.87v12.06a1.877 1.877 0 0 0 1.667 1.856c.015.012 9.2.024 9.2.024m1.85-11.93v-.01a.5.5 0 0 0-.13-.45l-.68-.7h3.97v1.24h-3.15v-.02a.127.127 0 0 0-.01-.06m.01 1.83h3.15V15.4h-3.15zm0 2.99h3.15v1.24h-3.15zm2.85-10.03 1.37 1.41h-1.37zm-8.67.01a.871.871 0 0 1 .87-.87l6.8-.03v2.8a.5.5 0 0 0 .5.5h2.55l.02 9.66a.871.871 0 0 1-.87.87h-4.05v-1.17h3.65v-2.24h-3.65V15.9h3.65v-2.24h-3.65v-.75h3.65v-2.24h-4.96l-1.9-1.94v-.01a.555.555 0 0 0-.08-.06.855.855 0 0 0-.57-.21h-1.96zm4.12 4.59h-1.37v-1.41l.35.36h.01l.48.5zM7.675 22.382v-12.06a.871.871 0 0 1 .87-.87l4.04-.02h1l1.75-.01v2.8a.406.406 0 0 0 .04.19H18.4v4.74l.01 1.24v3.99a.879.879 0 0 1-.87.88H8.545a.879.879 0 0 1-.87-.88",
    style: {
      fill: "#dcea8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2842",
    d: "M21.329 22.547c-3.329 6.18-11.142 2.684-11.142 2.684a8.232 8.232 0 0 0 5.952 2.547 9.278 9.278 0 0 0 8.3-5.231z",
    style: {
      fill: "#dcea8d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.7f5329495856236a62dfaf62d776dce6.svg";
export { ForwardRef as ReactComponent };